/**
 * Available roles as configured in Keycloak realm settings
 */
export const ROLES = {
  USER: 'MUser',
  ADMIN: 'MAdmin',
};

export const EMAIL_MAX_LENGTH = 255;
export const PASSWORD_MAX_LENGTH = 50;
export const NAME_MAX_LENGTH = 50;
